import dayjs from 'dayjs';

export function convertCalendarEvent(event) {
    var self = this;

    var djStart = dayjs(event.StartDate);
    var start = djStart.toISOString(),
        startDate = djStart.format("M/D/YYYY"),
        startMonth = djStart.month(),
        startDay = djStart.day(),
        startYear = djStart.year();
    var djEnd = dayjs(event.EndDate);
    var end = djEnd.toISOString(),
        endDate = djEnd.format("M/D/YYYY"),
        endMonth = djEnd.month(),
        endDay = djEnd.day(),
        endYear = djEnd.year();
    var eventUrl = event.Url,
        eventTitle = event.Name,
        cancelled = event.Cancelled,
        eventColor = event.EventColor,
        eventId = event.Id,
        startTime = djStart.format("hh:mm:ss a"),
        endTime = djEnd.format("hh:mm:ss a"),
        eventLink = '';

    if (eventUrl) {
        eventLink = 'href="' + eventUrl + '"';
    }

    var eventDescription = event.Description;
    if (eventDescription === null) {
        eventDescription = "";
    }

    var locationName = event.LocationName;
    if (locationName === null) {
        locationName = "";
    }

    var locationAddress1 = event.LocationAddress1;
    if (locationAddress1 === null) {
        locationAddress1 = "";
    }

    var locationAddress2 = event.LocationAddress2;
    if (locationAddress2 === null) {
        locationAddress2 = "";
    }

    var contactName = event.ContactName;
    if (contactName === null) {
        contactName = "";
    }

    var contactEmail = event.ContactEmail;
    if (contactEmail === null) {
        contactEmail = "";
    }

    var contactPhone = event.ContactPhone;
    if (contactPhone === null) {
        contactPhone = "";
    }

    return {
        eventId: eventId,
        start: start,
        startDate: startDate,
        startTime: startTime,
        startMonth: startMonth,
        startDay: startDay,
        startYear: startYear,
        end: end,
        endDate: endDate,
        endTime: endTime,
        endDay: endDay,
        endMonth: endMonth,
        endYear: endYear,
        eventUrl: eventUrl,
        eventTitle: eventTitle,
        cancelled: cancelled,
        eventColor: eventColor,
        eventLink: eventLink,
        eventDescription: eventDescription,
        locationName: locationName,
        locationAddress1: locationAddress1,
        locationAddress2: locationAddress2,
        contactName: contactName,
        contactEmail: contactEmail,
        contactPhone: contactPhone
    }
}